import { DeviceWithAssetAndRadioData } from '../../entities/device-radios-v2/device-with-asset-and-radio-data-response';
import {
  DeviceCheckInDetails,
  MessageTransmissionDetails,
} from '../../entities/devices-v1/device-checkin-details';

export enum devicesActionNames {
  SET_DEVICE = 'SET_DEVICE',
  SET_CHECK_IN_DETAILS = 'SET_CHECK_IN_DETAILS',
  SET_MESSAGE_TRANSMISSION_DETAILS = 'SET_MESSAGE_TRANSMISSION_DETAILS',
  CLEAR_MESSAGE_TRANSMISSION_DETAILS = 'CLEAR_MESSAGE_TRANSMISSION_DETAILS',
  SET_IS_SUSPENDED_DEVICE = 'SET_IS_SUSPENDED_DEVICE',
  SET_HOMING_SERVICE_RESPONSE = 'SET_HOMING_SERVICE_ERROR',
  SET_IS_RESTRICTED_DEVICE = 'SET_IS_RESTRICTED_DEVICE',
}

export interface DevicesState {
  selectedDevice: DeviceWithAssetAndRadioData | undefined;
  checkInDetails: DeviceCheckInDetails | undefined;
  messageTransmissionDetails: MessageTransmissionDetails | undefined;
  suspendedDevice: boolean;
  restrictedDevice: boolean;
  homingService: {
    proposedRoute: string | undefined;
    page: string | undefined;
    error: number | undefined;
    option: any | undefined;
    isDeviceNotPresent?: boolean;
  };
}

interface SetDeviceAction {
  type: typeof devicesActionNames.SET_DEVICE;
  payload: DeviceWithAssetAndRadioData;
}

interface SetCheckInDetails {
  type: typeof devicesActionNames.SET_CHECK_IN_DETAILS;
  payload: DeviceCheckInDetails;
}

interface SetMessageTransmissionDetails {
  type: typeof devicesActionNames.SET_MESSAGE_TRANSMISSION_DETAILS;
  payload: MessageTransmissionDetails;
}

interface ClearMessageTransmissionDetails {
  type: typeof devicesActionNames.CLEAR_MESSAGE_TRANSMISSION_DETAILS;
  payload: {
    deviceKey: string;
  };
}
interface SetIsIsSuspendedDevice {
  type: typeof devicesActionNames.SET_IS_SUSPENDED_DEVICE;
  payload: boolean;
}
interface SetIsIsRestrictedDevice {
  type: typeof devicesActionNames.SET_IS_RESTRICTED_DEVICE;
  payload: boolean;
}
interface SetHomingService {
  type: typeof devicesActionNames.SET_HOMING_SERVICE_RESPONSE;
  payload: {
    proposedRoute: string | undefined;
    page: string | undefined;
    error: number | undefined;
    option: any | undefined;
    isDeviceNotPresent?: boolean;
  };
}

export type DevicesActionTypes =
  | SetDeviceAction
  | SetIsIsRestrictedDevice
  | SetCheckInDetails
  | SetMessageTransmissionDetails
  | ClearMessageTransmissionDetails
  | SetIsIsSuspendedDevice
  | SetHomingService;
